import { useState } from 'react';
import { useCandidate } from '~/hooks/useCandidate';
import { useSelectedOffice } from '~/hooks/useSelectedOffice';
import { Ribbon } from '@tempmee/react';
import { UserProfession } from '../../../enums/UserProfession';
import { EducationUtils } from '../../../utils/EducationUtils';
import SkillsMismatchPopup from '../../SkillsMismatchPopup';

export const WarningBanner = ({ candidate, job }) => {
  const user = useSelectedOffice(job?.offer_owner?.id);
  const { specialtyMatch, insuranceMismatch } = useCandidate(user, candidate, job);
  const [showModal, setShowModal] = useState(false);

  const renderWarningDescription = () => {
    if (job.profession === UserProfession.DN) {
      let description = '';

      if (!specialtyMatch && insuranceMismatch) {
        description =
          'This professional does not have experience in all procedures needed or the same Insurance Provider.';
      } else if (!specialtyMatch) {
        description = 'This professional does not have experience in all procedures needed.';
      } else if (insuranceMismatch) {
        description = 'This professional does not have the same Insurance Provider.';
      }

      return <>{description}</>;
    }

    return (
      <>
        This professional does not have your preferred specialty,{' '}
        <strong>{EducationUtils.removeSpecialtyPrefix(job?.specialty)}</strong>.
      </>
    );
  };

  return !specialtyMatch || insuranceMismatch ? (
    <>
      <Ribbon
        variant="soft-warning"
        onClick={() => {
          if (!specialtyMatch) {
            setShowModal(true);
          }
        }}
        style={{ width: '100%' }}
      >
        {renderWarningDescription()}
      </Ribbon>

      {showModal && (
        <SkillsMismatchPopup
          onButtonPress={() => setShowModal(false)}
          missingSkills={EducationUtils.removeSpecialtyPrefix(job?.specialty)}
        />
      )}
    </>
  ) : null;
};
